<template>
  <el-dialog :visible.sync="visible" :title="data ? '编辑展厅' : '新增展厅'" width="900px" @close="closeDialog" custom-class="showroom-dialog">
    <div class="layout-container">
      <!-- 左侧地图区域 -->
      <div class="map-section">
        <div class="map-search-container">
          <el-input 
            v-model="searchKeyword" 
            placeholder="搜索地点" 
            class="map-search-input"
            @keyup.enter.native="searchPlace"
          >
            <el-button slot="append" icon="el-icon-search" @click="searchPlace"></el-button>
          </el-input>
          <el-button type="primary" size="small" icon="el-icon-location" class="location-btn" @click="getCurrentLocation"></el-button>
        </div>
        
        <!-- 搜索结果列表 -->
        <div class="search-results" v-if="searchResults.length > 0">
          <el-card shadow="never" class="search-results-card">
            <div slot="header" class="search-results-header">
              <span>搜索结果</span>
              <el-button type="text" icon="el-icon-close" @click="clearSearchResults"></el-button>
            </div>
            <ul class="search-results-list">
              <li 
                v-for="(result, index) in searchResults" 
                :key="index" 
                @click="selectSearchResult(result)"
                class="search-result-item"
              >
                <div class="result-title">{{ result.name }}</div>
                <div class="result-address">{{ result.address }}</div>
              </li>
            </ul>
          </el-card>
        </div>
        
        <div id="map" ref="mapContainer" class="map-container"></div>
      </div>
      
      <!-- 右侧表单区域 -->
      <div class="form-section">
        <el-form :model="form" label-width="90px" class="form-container">
          <el-form-item label="名称"><el-input v-model="form.name" /></el-form-item>
          <el-form-item label="地址"><el-input v-model="form.address" /></el-form-item>
          <el-form-item label="电话"><el-input v-model="form.phone" /></el-form-item>
          <el-form-item label="品牌">
            <el-select v-model="form.brand_id" placeholder="请选择品牌" clearable>
              <el-option
                v-for="brand in brandList"
                :key="brand.id"
                :label="brand.name"
                :value="brand.id"
              >
                <span style="float: left">{{ brand.name }}</span>
                <img v-if="brand.icon" :src="brand.icon" style="float: right; width: 20px; height: 20px; object-fit: contain;" />
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签"><el-input v-model="form.tags" placeholder="多个标签用逗号分隔" /></el-form-item>
          <el-form-item label="营业时间"><el-input v-model="form.business_hours" /></el-form-item>
          <el-form-item label="简介"><el-input type="textarea" v-model="form.description" /></el-form-item>
          <el-form-item label="产品"><el-input type="textarea" v-model="form.products" /></el-form-item>
          <el-form-item label="经纬度">
            <el-input v-model="form.latitude" style="width:45%" placeholder="纬度" />
            <el-input v-model="form.longitude" style="width:45%;margin-left:10%" placeholder="经度" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ShowroomForm',
  props: { visible: Boolean, data: Object },
  data() {
    return {
      form: {
        name: '', address: '', phone: '', tags: '', business_hours: '', description: '', products: '', latitude: '', longitude: '', brand_id: ''
      },
      brandList: [],
      map: null,
      marker: null,
      mapLoaded: false,
      searchKeyword: '',
      amapKey: 'ca4f9537b05a7c63f1b208ebbdd977ab',
      amapSecurityJsCode: 'e3429b9bd7d6f8f3ee4c98735fdbe2df',
      searchResults: [],
      infoWindow: null
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = this.data ? { ...this.data } : { name: '', address: '', phone: '', tags: '', business_hours: '', description: '', products: '', latitude: '', longitude: '', brand_id: '' };
        this.loadBrandList();
        this.$nextTick(() => {
          this.initMap();
        });
      } else {
        // 关闭对话框时清空搜索结果和关键词
        this.searchResults = [];
        this.searchKeyword = '';
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
    },
    async loadBrandList() {
      try {
        const headers = { Authorization: localStorage.getItem('token') };
        const response = await axios.get('/api/admin/brand', { headers });
        this.brandList = response.data.data;
      } catch (error) {
        console.error('加载品牌列表失败:', error);
      }
    },
    async onSubmit() {
      const headers = { Authorization: localStorage.getItem('token') };
      try {
        if (this.form.id) {
          await axios.put(`/api/admin/showroom/${this.form.id}`, this.form, { headers });
          this.$message.success('修改成功');
        } else {
          await axios.post('/api/admin/showroom', this.form, { headers });
          this.$message.success('新增成功');
        }
        this.$emit('refresh');
        this.closeDialog();
      } catch (error) {
        this.$message.error('操作失败：' + (error.response && error.response.data && error.response.data.message || '未知错误'));
      }
    },
    
    // 获取用户当前位置
    getCurrentLocation() {
      this.$message.info('正在获取当前位置...');
      
      // 使用浏览器原生的Geolocation API获取位置
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          // 成功回调
          (position) => {
            // 获取经纬度
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            
            // 更新表单经纬度
            this.form.latitude = lat.toFixed(6);
            this.form.longitude = lng.toFixed(6);
            
            // 更新地图位置和标记
            if (this.map) {
              // 高德地图使用的是[lng, lat]格式
              this.map.setCenter([lng, lat]);
              
              // 清除旧标记
              if (this.marker) {
                this.map.remove(this.marker);
              }
              
              // 添加新标记
              this.marker = new AMap.Marker({
                position: [lng, lat],
                animation: 'AMAP_ANIMATION_DROP'
              });
              this.map.add(this.marker);
              
              // 获取地址信息
              this.getAddressFromLocation(lng, lat);
            }
            
            this.$message.success('已定位到当前位置');
          },
          // 错误回调
          (error) => {
            console.error('获取位置错误:', error);
            let errorMsg = '获取位置失败';
            
            // 根据错误代码提供更具体的错误信息
            switch(error.code) {
              case error.PERMISSION_DENIED:
                errorMsg = '用户拒绝了位置请求';
                break;
              case error.POSITION_UNAVAILABLE:
                errorMsg = '位置信息不可用';
                break;
              case error.TIMEOUT:
                errorMsg = '获取位置超时';
                break;
              case error.UNKNOWN_ERROR:
                errorMsg = '发生未知错误';
                break;
            }
            
            this.$message.error(`${errorMsg}，请使用搜索功能`);
          },
          // 选项
          {
            enableHighAccuracy: true, // 高精度
            timeout: 10000,           // 超时时间，单位毫秒
            maximumAge: 0             // 不使用缓存
          }
        );
      } else {
        this.$message.error('您的浏览器不支持地理定位，请使用搜索功能');
      }
    },
    
    // 根据经纬度获取地址信息
    getAddressFromLocation(lng, lat) {
      // 使用高德Web服务API的逆地理编码
      const url = `https://restapi.amap.com/v3/geocode/regeo?location=${lng},${lat}&key=${this.amapKey}&radius=1000&extensions=all`;
      
      axios.get(url)
        .then(response => {
          const data = response.data;
          console.log('逆地理编码响应:', data);
          
          if (data.status === '1' && data.regeocode) {
            // 更新地址（如果地址为空）
            if (!this.form.address && data.regeocode.formatted_address) {
              this.form.address = data.regeocode.formatted_address;
            }
          }
        })
        .catch(error => {
          console.error('逆地理编码请求错误:', error);
        });
    },
    
    initMap() {
      if (!window.AMap) {
        if (!this.mapLoaded) {
          this.mapLoaded = true;
          
          // 动态加载高德地图API
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = `https://webapi.amap.com/maps?v=2.0&key=${this.amapKey}`;
          script.onerror = (e) => {
            console.error('地图脚本加载错误:', e);
            this.$message.error('地图加载失败，请检查网络连接或API Key');
            this.mapLoaded = false;
          };
          
          // 定义全局回调函数
          window.initAMap = () => {
            console.log('高德地图API加载完成');
            this.renderMap();
          };
          
          // 添加加载完成回调
          script.onload = window.initAMap;
          
          document.head.appendChild(script);
        }
      } else {
        this.renderMap();
      }
    },
    
    renderMap() {
      if (!window.AMap) {
        console.error('地图API未加载，无法渲染地图');
        return;
      }
      
      // 确保地图容器存在
      const mapContainer = this.$refs.mapContainer;
      if (!mapContainer) {
        console.error('地图容器不存在');
        return;
      }
      
      // 设置默认坐标（北京市中心）
      const defaultLat = 39.908823;
      const defaultLng = 116.39747;
      
      // 使用表单中的坐标或默认坐标
      const lat = this.form.latitude ? parseFloat(this.form.latitude) : defaultLat;
      const lng = this.form.longitude ? parseFloat(this.form.longitude) : defaultLng;
      
      try {
        console.log('初始化高德地图，中心点:', lat, lng);
        
        // 创建地图实例
        this.map = new AMap.Map(mapContainer, {
          center: [lng, lat], // 高德地图使用[lng, lat]格式
          zoom: 13,
          mapStyle: 'amap://styles/normal'
        });
        
        // 创建标记
        this.marker = new AMap.Marker({
          position: [lng, lat],
          map: this.map,
          animation: 'AMAP_ANIMATION_DROP'
        });
        
        // 添加点击事件，允许用户通过点击地图选择位置
        this.map.on('click', (e) => {
          const lng = e.lnglat.getLng();
          const lat = e.lnglat.getLat();
          
          this.form.latitude = lat.toFixed(6);
          this.form.longitude = lng.toFixed(6);
          
          // 更新标记位置
          this.marker.setPosition([lng, lat]);
          
          // 获取点击位置的地址信息
          this.getAddressFromLocation(lng, lat);
        });
        
        console.log('高德地图渲染完成');
      } catch (error) {
        console.error('地图渲染错误:', error);
        this.$message.error('地图渲染失败: ' + error.message);
      }
    },
    
    // 搜索地点
    searchPlace() {
      if (!this.searchKeyword.trim()) {
        this.$message.warning('请输入搜索关键词');
        return;
      }
      
      if (!this.map || !window.AMap) {
        this.$message.error('地图未加载完成，请稍后重试');
        return;
      }
      
      this.$message.info('正在搜索...');
      console.log('开始搜索:', this.searchKeyword);
      
      // 直接执行搜索，不再依赖placeSearch对象
      this.doSearch();
    },
    
    // 执行搜索
    doSearch() {
      // 使用高德Web服务API进行搜索，而不是JS API
      const url = `https://restapi.amap.com/v3/place/text?keywords=${encodeURIComponent(this.searchKeyword)}&key=${this.amapKey}&city=全国&children=1&offset=20&page=1&extensions=all`;
      
      axios.get(url)
        .then(response => {
          const data = response.data;
          console.log('搜索响应:', data);
          
          if (data.status === '1' && data.pois && data.pois.length > 0) {
            // 处理所有搜索结果，格式化为便于使用的数据结构
            this.searchResults = data.pois.map(poi => {
              const location = poi.location.split(',');
              return {
                name: poi.name,
                address: poi.address || poi.pname + poi.cityname + poi.adname + poi.address,
                longitude: location[0],
                latitude: location[1],
                district: poi.adname,
                city: poi.cityname,
                province: poi.pname,
                raw: poi // 保存原始数据，以备后用
              };
            });
            
            // 自动处理第一个结果（在地图上显示，但不选择）
            const firstPOI = this.searchResults[0];
            const lng = parseFloat(firstPOI.longitude);
            const lat = parseFloat(firstPOI.latitude);
            
            // 移动地图到第一个结果位置
            this.map.setCenter([lng, lat]);
            this.map.setZoom(15);
            
            // 显示信息窗口
            if (this.infoWindow) {
              this.infoWindow.close();
            }
            
            this.infoWindow = new AMap.InfoWindow({
              content: `<div style="padding:10px;">${firstPOI.name}</div>`,
              position: [lng, lat],
              offset: new AMap.Pixel(0, -30)
            });
            
            this.infoWindow.open(this.map);
            
            this.$message.success(`找到 ${this.searchResults.length} 个结果，请从列表中选择`);
          } else {
            console.error('搜索失败:', data);
            this.$message.warning('未找到相关位置，请尝试更详细的关键词');
          }
        })
        .catch(error => {
          console.error('搜索请求错误:', error);
          this.$message.error('位置搜索失败，请稍后重试');
        });
    },
    
    // 设置位置方法
    setLocation(lat, lng) {
      if (!lat || !lng || !this.map) return;
      
      // 更新表单经纬度
      this.form.latitude = parseFloat(lat).toFixed(6);
      this.form.longitude = parseFloat(lng).toFixed(6);
      
      // 更新标记位置
      this.marker.setPosition([lng, lat]);
      
      // 移动地图
      this.map.setCenter([lng, lat]);
      
      // 获取地址信息
      this.getAddressFromLocation(lng, lat);
    },
    
    // 选择搜索结果
    selectSearchResult(result) {
      // 更新表单数据
      this.form.latitude = result.latitude;
      this.form.longitude = result.longitude;
      
      // 如果表单地址为空，或者用户选择了新的地址，则更新地址
      if (!this.form.address || this.searchResults.length > 0) {
        this.form.address = result.address;
      }
      
      // 如果名称为空，可以使用搜索结果的名称作为默认建议
      if (!this.form.name) {
        this.form.name = result.name;
      }
      
      // 在地图上显示选择的位置
      const lng = parseFloat(result.longitude);
      const lat = parseFloat(result.latitude);
      
      // 更新标记位置
      this.marker.setPosition([lng, lat]);
      
      // 移动地图中心
      this.map.setCenter([lng, lat]);
      
      // 更新信息窗口
      if (this.infoWindow) {
        this.infoWindow.close();
      }
      
      this.infoWindow = new AMap.InfoWindow({
        content: `<div style="padding:10px;">${result.name}</div>`,
        position: [lng, lat],
        offset: new AMap.Pixel(0, -30)
      });
      
      this.infoWindow.open(this.map);
      
      // 选择后清空搜索结果列表
      this.$message.success(`已选择: ${result.name}`);
      this.searchResults = [];
    },
    
    // 清空搜索结果
    clearSearchResults() {
      this.searchResults = [];
    }
  }
};
</script>

<style scoped>
/* 修复对话框滚动问题 */
.showroom-dialog {
  display: flex;
  flex-direction: column;
  margin-top: 15vh !important;
  max-height: 70vh;
  overflow: hidden;
}

.showroom-dialog .el-dialog__body {
  overflow-y: auto;
  padding: 20px 20px;
}

.showroom-dialog .el-dialog__header,
.showroom-dialog .el-dialog__footer {
  flex-shrink: 0;
}

/* 两栏布局容器 */
.layout-container {
  display: flex;
  gap: 20px;
  height: 100%;
}

/* 左侧地图区域 */
.map-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0; /* 防止溢出 */
}

/* 右侧表单区域 */
.form-section {
  flex: 1;
  min-width: 0; /* 防止溢出 */
}

/* 确保表单内容可以滚动 */
.form-container {
  width: 100%;
}

/* 地图容器样式 */
.map-container {
  width: 100%;
  height: 400px;
  border-radius: 4px;
  overflow: hidden;
}

/* 地图搜索相关样式 */
.map-search-container {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.map-search-input {
  flex: 1;
}

.location-btn {
  white-space: nowrap;
}

/* 搜索结果相关样式 */
.search-results {
  margin-bottom: 10px;
  max-height: 300px;
  position: absolute;
  width: 100%;
  z-index: 100;
}

.search-results-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-height: 300px;
  overflow-y: auto;
}

.search-results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e6e6e6;
}

.search-results-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.search-result-item {
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #e6e6e6;
  transition: background-color 0.3s;
}

.search-result-item:hover {
  background-color: #f0f9eb;
}

.search-result-item:last-child {
  border-bottom: none;
}

.result-title {
  font-weight: bold;
  font-size: 14px;
}

.result-address {
  margin-top: 5px;
  color: #606266;
  font-size: 12px;
}
</style>